import { has } from 'lodash';
import { ACTIONS } from '../Constants';
import { assignTeamDetails } from '../utils/CollectionUtils';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

/**
 *
 * @param {Object} params
 * @param {String} actionType
 * @return {function(*)}
 * @private
 */
const _getManyUserCollections = (params, actionType) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/usercollections`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.GET_MANY_USER_COLLECTIONS_START
        });
        return VerbFetch(url).then((body) => {
            const { teams } = getState();
            const newCollections = assignTeamDetails(body, teams);
            dispatch({
                type: actionType,
                payload: {
                    userCollections: newCollections
                }
            });

            return newCollections;
        });
    };
};

/**
 *
 * @param {Object} query
 * @return {function(*)}
 */
export const getFilteredUserCollections = (query) =>
    _getManyUserCollections(query, ACTIONS.GET_FILTERED_USER_COLLECTIONS);

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
export const getManyUserCollections = (params) => _getManyUserCollections(params, ACTIONS.GET_MANY_USER_COLLECTIONS);

export const getUserCollection = (params) => {
    const { userCollectionId, pathsContext } = params;

    const url = `${pathsContext.serverUrl}/usercollections/${userCollectionId}`;

    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.GET_USER_COLLECTION_START,
            payload: {
                userCollectionId
            }
        });
        return VerbFetch(url).then((body) => {
            const { teams } = getState();
            const [newCollections] = assignTeamDetails([body], teams);

            dispatch({
                type: ACTIONS.GET_USER_COLLECTION,
                payload: {
                    userCollection: newCollections
                }
            });
            return newCollections;
        });
    };
};

export const postUserCollection = (params) => {
    const { body, pathsContext } = params;
    if (has(body, 'testEmailAddress')) {
        delete body.testEmailAddress;
    }

    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.POST_USER_COLLECTION_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.serverUrl}/usercollections`, {
            method: 'POST',
            body
        }).then((body) => {
            const { teams } = getState();
            const [newCollections] = assignTeamDetails([body], teams);

            dispatch({
                type: ACTIONS.POST_USER_COLLECTION_SUCCESS,
                payload: {
                    userCollection: newCollections
                }
            });
            return newCollections;
        });
    };
};

export const putUserCollection = (params) => {
    const { userCollectionId, body, pathsContext } = params;
    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.PUT_USER_COLLECTION_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.serverUrl}/usercollections/${userCollectionId}`, {
            method: 'PUT',
            body
        }).then((body) => {
            const { teams } = getState();
            const [newCollections] = assignTeamDetails([body], teams);

            dispatch({
                type: ACTIONS.PUT_USER_COLLECTION_SUCCESS,
                payload: {
                    userCollection: newCollections
                }
            });
            return newCollections;
        });
    };
};

export const putUserCollectionStatus = (params) => {
    const { userCollectionId, newStatus, collectionId, userProfileId, pathsContext } = params;
    return VerbFetch(`${pathsContext.serverUrl}/usercollections/${userCollectionId}/status`, {
        method: 'PUT',
        body: {
            newStatus,
            collectionId,
            userProfileId
        }
    });
};

export const putUserCollectionContent = (params) => {
    const { userCollectionId, pathsContext } = params;
    return (dispatch, getState) => {
        dispatch({
            type: ACTIONS.PUT_USER_COLLECTION_CONTENT_START,
            payload: userCollectionId
        });
        return VerbFetch(`${pathsContext.serverUrl}/usercollections/${userCollectionId}/userlearningassets`, {
            method: 'PUT'
        }).then((body) => {
            const { teams } = getState();
            const [newCollections] = assignTeamDetails([body], teams);

            dispatch({
                type: ACTIONS.PUT_USER_COLLECTION_CONTENT_SUCCESS,
                payload: {
                    userCollection: newCollections
                }
            });
            return newCollections;
        });
    };
};

export const deleteUserCollection = (params) => {
    const { userCollectionId, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.DELETE_USER_COLLECTION_START,
            payload: {
                userCollectionId
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/usercollections/${userCollectionId}`, {
            method: 'DELETE'
        }).then(() => {
            dispatch({
                type: ACTIONS.DELETE_USER_COLLECTION_SUCCESS,
                payload: {
                    userCollectionId
                }
            });
        });
    };
};

export const postCompletionNotification = (params) => {
    const { userId, collectionId, pathsContext } = params;
    return (dispatch) => {
        return VerbFetch(`${pathsContext.serverUrl}/usercollections/completion-notification/${userId}`, {
            method: 'POST',
            body: { collectionId }
        })
            .then((result) => result)
            .catch((err) => {
                console.error(err);
                throw err;
            });
    };
};

export const clearSearchedUserCollections = () => (dispatch) =>
    dispatch({
        type: ACTIONS.CLEAR_SEARCHED_USER_COLLECTIONS
    });

export const removeUserCollection = ({ userCollectionId }) => (dispatch) => {
    dispatch({
        type: ACTIONS.REMOVE_USER_COLLECTION,
        payload: {
            userCollectionId
        }
    });
};

export const clearUserCollections = () => (dispatch) =>
    dispatch({
        type: ACTIONS.CLEAR_USER_COLLECTIONS
    });
